import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";

export class PreviousObstetricsHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Gravidity: "",
      Parity: "",
      Term: "",
      Preterm: "",
      Abortion: "",
      PostTerm: "",
      NumChildrenAlive: "",
      AgeLastInfant: "",
      NumStillBirth: "",
      NumNeonatalDeathFirstWeek: "",
      NumNeonatalDeath8thTo28thDays: "",
      visitid: "",
      patientName: localStorage.getItem("currentVisitName"),
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    var value = $(".PreviousDone").val();
    if (value == "yes") {
      $(".PreplanTable").show();
    } else {
      $(".PreplanTable").hide();
    }
  }

  proceedEvent(event) {
    window.location.href = "/previous/obstetrics/pregnancy/history";
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/obstetrichistory/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            // alert('sdsd')
            $(".HistoryModal").show();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      Gravidity,
      Parity,
      Term,
      Preterm,
      Abortion,
      PostTerm,
      NumChildrenAlive,
      AgeLastInfant,
      NumStillBirth,
      NumNeonatalDeathFirstWeek,
      NumNeonatalDeath8thTo28thDays,
      visitid,
      patientName,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar></TriageSidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Previous Obstetrics History
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Gravidity
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Gravidity}
                      name="Gravidity"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Parity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Parity}
                      name="Parity"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Term
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Term}
                      name="Term"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Preterm
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Preterm}
                      name="Preterm"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Abortion
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Abortion}
                      name="Abortion"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Children Alive
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumChildrenAlive}
                      name="NumChildrenAlive"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Age Of Last Infant
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AgeLastInfant}
                      name="AgeLastInfant"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number Of StillBirth
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumStillBirth}
                      name="NumStillBirth"
                      type="number"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Neonatal Death in the first week
                    </h6>
                    <input
                      className="form-control"
                      name="NumNeonatalDeathFirstWeek"
                      onChange={this.handleChange}
                      value={NumNeonatalDeathFirstWeek}
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Neonatal Death between the 8th to 28th days
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumNeonatalDeath8thTo28thDays}
                      name="NumNeonatalDeath8thTo28thDays"
                      type="number"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Obstetrics History Saved
                Successfully.
              </div>

              <div
                className="modal HistoryModal"
                style={autoscroll}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        {patientName}`s Previous Obstetrics History Modal
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                      <br />
                      <a
                        className="btn btn-danger proceed"
                        onClick={this.proceedEvent}
                        style={width100}
                      >
                        Proceed to Next
                      </a>
                      <Preview id={"jsx-template"}>
                        <b>NAME: </b>
                        {patientName}

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Gravidity
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Gravidity}
                            name="Gravidity"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Parity
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Parity}
                            name="Parity"
                            type="text"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Term
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Term}
                            name="Term"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Preterm
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Preterm}
                            name="Preterm"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Gravidity
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Gravidity}
                            name="Gravidity"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Parity
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Parity}
                            name="Parity"
                            type="text"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Term
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Term}
                            name="Term"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Preterm
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Preterm}
                            name="Preterm"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Number of Neonatal Death in the first week
                          </h6>
                          <input
                            className="form-control"
                            name="NumNeonatalDeathFirstWeek"
                            readOnly
                            value={NumNeonatalDeathFirstWeek}
                            type="text"
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Number of Neonatal Death between the 8th to 28th
                            days
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={NumNeonatalDeath8thTo28thDays}
                            name="NumNeonatalDeath8thTo28thDays"
                            type="text"
                            required
                          />
                        </div>
                      </Preview>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PreviousObstetricsHistory;
